import { render, staticRenderFns } from "./main.vue?vue&type=template&id=a43b41a6&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43b41a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a43b41a6')) {
      api.createRecord('a43b41a6', component.options)
    } else {
      api.reload('a43b41a6', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=a43b41a6&scoped=true", function () {
      api.rerender('a43b41a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/view/components/modal-select-campaign/main.vue"
export default component.exports